import type { IScanResult } from '../models/ScanResult';
import { values } from '../rules/ruleUtils';
import type { IKnownNames, ITagSet } from './Tagging';

/** Enough for the AI to match against; keeps each request small. */
const MAX_NAMES: number = 50;

const ORGANIZATION_PARENTS: string[] = ['clients', 'customers', 'accounts', 'donors', 'partners', 'vendors', 'suppliers'];
const PROJECT_PARENTS: string[] = ['projects', 'programs', 'programmes', 'engagements'];

function add(list: string[], value: string | undefined): void {
  const v: string = (value ?? '').trim();
  if (v && list.length < MAX_NAMES && !list.some(x => x.toLowerCase() === v.toLowerCase())) {
    list.push(v);
  }
}

/**
 * Organization and project names the library already uses: folders directly inside a
 * Clients- or Projects-like folder, and tag values already written to files.
 */
export function knownNames(scan: IScanResult, tags?: { [fileId: string]: ITagSet }): IKnownNames {
  const known: IKnownNames = { organizations: [], projects: [] };
  for (const tagSet of values(tags ?? {})) {
    add(known.organizations, tagSet.organization);
    add(known.projects, tagSet.project);
  }
  for (const folder of values(scan.folders).sort((a, b) => a.path.localeCompare(b.path))) {
    const parent = scan.folders[folder.parentId ?? ''];
    const parentName: string = parent ? parent.name.toLowerCase() : '';
    if (ORGANIZATION_PARENTS.indexOf(parentName) !== -1) {
      add(known.organizations, folder.name);
    } else if (PROJECT_PARENTS.indexOf(parentName) !== -1) {
      add(known.projects, folder.name);
    }
  }
  return known;
}
